<template>
    <div>
        <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader"></h3>
        <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
                <el-form-item label="审批状态">
                    <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
                        <el-option v-for="item in $store.state.reviewStatus" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleQuery">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <custom-table :data="tableData" border style="width: 100%">
                <custom-table-column fixed label="序号" type="index" width="50">
                </custom-table-column>
                <custom-table-column prop="activity_name" fixed label="活动名称" min-width="180px">
                </custom-table-column>
                <custom-table-column prop="target_name" label="整改对象" min-width="160px">
                </custom-table-column>
                <custom-table-column prop="review_status_text" label="审批状态" width="100px">
                </custom-table-column>
                <custom-table-column prop="review_comment" label="审批意见" width="160px">
                </custom-table-column>
                <custom-table-column prop="rectification_desc" label="整改描述" min-width="180px">
                </custom-table-column>
                <custom-table-column label="附件" min-width="240px">
                    <template slot-scope="scope" v-if="scope.row.rectification_file">
                        <el-link type="primary" v-for="(item, index) in scope.row.rectification_file.split(',')"
                            :href="item" :key="index" target="_blank">{{ $until.getFileName(item) }}</el-link>
                    </template>
                </custom-table-column>
                <custom-table-column prop="hazard_level_text" label="隐患等级" width="100px">
                </custom-table-column>
                <!-- <custom-table-column prop="rectification_status_text" label="整改状态" width="100px">
                </custom-table-column> -->
                <custom-table-column prop="rectification_limit_date" label="限定整改日期" width="160px">
                </custom-table-column>
                <custom-table-column label="隐患图片" min-width="240px">
                    <template slot-scope="scope" v-if="scope.row.image">
                        <el-image v-for="(img, index) in scope.row.image.split(',')" :key="index"
                            style="width: 50px; height: 50px" :src="img" :preview-src-list="scope.row.image.split(',')">
                        </el-image>
                    </template>
                </custom-table-column>
                <custom-table-column prop="description" label="隐患描述" min-width="180px">
                </custom-table-column>
            </custom-table>
            <div class="pageLine">
                <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
            </div>
        </div>
    </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
    name: 'equipmentInto',
    mixins: [mixinList, mixinValidate],
    data() {
        return {
            formInline: {
                status: '',
            },
            activeName: '1',
        };
    },
    components: {},
    created() {
    },
    mounted() {
    },
    methods: {
        async getList() {
            let params = this.$until.deleteNullPrototype(this.formInline);
            params.page = this.$refs.pageChild.page;
            params.size = this.$refs.pageChild.size;
            let res = await this.$api.instance.interfaceServer('api/hazard-rectification/review/list', 'get', params);
            if (res.code == 0 && res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
        },
        handleQuery() {
            this.$refs.pageChild.page = 1;
            this.getList();
        },
    },
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 1000px) {
    .pageHeader {
        border-bottom: 0;
    }

    /deep/.header-info-icon {
        bottom: 20px;
    }
}

@media screen and (min-width: 1000px) {
    .pageHeader {
        display: none;
    }
}

.pageHeader:before {
    width: var(--width);

}
</style>